import { captureException, withScope } from "@sentry/react";
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";

import Error from "./containers/Error";
import ErrorBoundary from "./containers/ErrorBoundary";
import { routeTree } from "./routeTree.gen";

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      withScope((scope) => {
        scope.setContext("query", { queryHash: query.queryHash });
        scope.setFingerprint([query.queryHash.replaceAll(/[0-9]/g, "0")]);
        captureException(error);
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (err, _variables, _context, mutation) => {
      withScope((scope) => {
        scope.setContext("mutation", {
          mutationId: mutation.mutationId,
          variables: mutation.state.variables,
        });
        if (mutation.options.mutationKey) {
          scope.setFingerprint(
            // Duplicate to prevent modification
            Array.from(mutation.options.mutationKey),
          );
        }
        captureException(err);
      });
    },
  }),
  defaultOptions: {
    queries: {
      // disables refetch when switching tabs
      refetchOnWindowFocus: false,
    },
  },
});

export const router = createRouter({
  routeTree,
  defaultNotFoundComponent: () => <Error code={404} />,
  defaultErrorComponent: ErrorBoundary,
  context: {
    queryClient,
    auth: undefined,
  },
  defaultPreload: "intent",
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});
